import React from "react";
import { Link } from "react-router-dom";



export default function VehicleFineDetail1() {
    return (
        <div className="vehiclefinedetail-container my-4">
            {/* Header */}
            <div className="special-header d-flex justify-content-between align-iteam">
            <h4 className="page-title pt-2">Vehicle Fine Details</h4>
            <div className="d-flex justify-content-between gap-2">
             <Link to="/updatevehiclefine" type="button" className="btn custom-btn">Edit</Link>
              <button type="button" className="btn custom-btn">Delete</button>
             </div>
            </div>

            {/* Table */}
            <div className="card col-md-12">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="custom-table  table-bordered mb-0">
                            <tbody>
                                <tr>

                                    <td style={{ width: "500px" }}>Vehicle Name</td>
                                    <td>New Vehicle</td>

                                </tr>
                                <tr>

                                    <td>Driver Name</td>
                                    <td>Super Fast</td>

                                </tr>
                                <tr>

                                    <td>Reason</td>
                                    <td>Over Speed</td>
                                   
                                </tr>

                                 <tr>

                                    <td>Date</td>
                                    <td>Thu Mar 3 2022</td>
                                   
                                </tr>

                                 <tr>

                                    <td>Status</td>
                                    <td>Active</td>
                                   
                                </tr>

                                 <tr>

                                    <td>Amount</td>
                                    <td>$1000</td>
                                   
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            
        </div>

    );

}